import { v4 as uuidv4 } from "uuid";

const changeSubscriptions = [];
const promises = {}; // Object for storing references to in progress promises

//In order to access theses functions from the C# side they need to be exposed via the window object as react is making all methods have a private scope
(function () {
	window.mobileService = {
		resolvePromise: function (promiseId, data, error) {
			return resolvePromise(promiseId, data, error);
		},
		alertOrientationChange: function() {
			return alertChange();
		}
	};
})();

// Called from C# as a response from a promise originally created from react, this finds the existing promise and sets the result enabling the originating react function to complete
// @param promiseId - id of the promise stored in global variable promises
function resolvePromise(promiseId, data, error) {
	if (error) {
		promises[promiseId].reject(data);

	} else {
		promises[promiseId].resolve(data);
	}

	// remove reference to stored promise
	delete promises[promiseId];
}

const isXamarin = () => {
	return !!(window.xamarinMethods);
};

//Xamarin Integrations

//When the xamarin code needs to return a value to be used in javascript a promise needs to be created:
//1. Generate a unique id to reference the promise later from native function
//2. Save reference to promise in the global variable
//3. Call C# injected function to start the C# execution
//4. Return promise to calling function, the C# code will resolve the promise (using the global variable)

function getCurrentOrientation() {
	if (isXamarin()) {
		const promise = new Promise(function (resolve, reject) {
			const promiseId = uuidv4();
			promises[promiseId] = { resolve, reject };

			window.xamarinMethods.getCurrentOrientation(promiseId);
		});

		return promise;
	}

	return Promise.resolve(1);
}

function getAllowedOrientation() {
	if (isXamarin()) {
		const promise = new Promise(function (resolve, reject) {
			const promiseId = uuidv4();
			promises[promiseId] = { resolve, reject };

			window.xamarinMethods.getAllowedOrientation(promiseId);
		});

		return promise;
	}

	return Promise.resolve(1);
}

function setAllowedOrientation(allowedOrientation) {
	if (isXamarin()) {
		const promise = new Promise((resolve, reject) => {
			const promiseId = uuidv4();
			promises[promiseId] = { resolve, reject };

			window.xamarinMethods.setAllowedOrientation(JSON.stringify([allowedOrientation, promiseId]));
		});

		return promise;
	}

	return Promise.resolve();
}

// Return the current app version string (version with build number, additional environment for non production builds)
function getCurrentAppVersion() {
	if (isXamarin()) {
		const promise = new Promise(function (resolve, reject) {
			const promiseId = uuidv4();
			promises[promiseId] = { resolve, reject };

			window.xamarinMethods.getCurrentVersion(promiseId);
		});

		return promise;
	}

	return Promise.resolve("");
}

//End of Xamarin Integrations

async function isLandscape() {

	if (isXamarin()) {
		if (await canRenderLandscape()) {
			if (window.screen.width > window.screen.height) {				
				return true;
			}

			const isForce = await isForceLandscape();

			if (isForce === true) {				
			}
			return isForce;
		}
	}

	return false;
}

async function allowLandscape() {

	await setAllowedOrientation("0");

	await alertChange();
}

async function canRenderLandscape() {

	if (isXamarin()) {
		try {

			const allowedOrientations = await getAllowedOrientation();
			
			switch (allowedOrientations) {
				case 0: //Unknown (Allow any orientation)
					{
						return true;
					}
				case 1: //Portrait
					{
						return false;
					}
				case 2: //Landscape
					{
						return true;
					}
				default:
					{
						console.error("Orientation value not supported: ", allowedOrientations);
						return false;
					}
			}
		}
		catch (ex) {
			console.error("Error while getting allowed orientation: ", ex);
			return false;
		}
	}

	return false;
}

function landscapeAllowed() {
	return canRenderLandscape();
}

async function toggleAllowLandscape() {
	const prev = await canRenderLandscape();

	const toggleTo = prev ? "0" : "1";

	await setAllowedOrientation(toggleTo);

	await alertChange();
}

async function isForceLandscape() {

	if (isXamarin()) {
		try {
			const currentOrientation = await getCurrentOrientation();
			
			switch (currentOrientation) {
				case 0: //Unknown (Allow any orientation)
					{
						return false;
					}
				case 1: //Portrait
					{
						return false;
					}
				case 2: //Landscape
					{
						return true;
					}
				default:
					{
						console.error("Orientation value not supported: ", currentOrientation);
						return false;
					}
			}
		}
		catch (ex) {
			console.error(ex);
			return false;
		}
	}

	return false;
}

async function toggleForceLandscape() {
	const prev = await isForceLandscape();

	const toggleTo = prev ? "0" : "2";

	await setAllowedOrientation(toggleTo);

	await alertChange();
}

async function resetLandscape() {
	const prev = await canRenderLandscape();

	await setAllowedOrientation("1");

	if (prev) {
		await alertChange();
	}
}

async function forceLandscape(shouldForceLandscape) {

	const allowedOrientation = shouldForceLandscape ? "2" : "0";

	await setAllowedOrientation(allowedOrientation);

	await alertChange();
}

function subscribeToLandscapeChange(name, func) {

	changeSubscriptions.push({ name, func });
}

function unsubscribeFromLandscapeChange(name) {
	if (changeSubscriptions.length > 0) {
		const index = changeSubscriptions.findIndex(e => e.name === name);
		if (index > -1) {
			changeSubscriptions.splice(index, 1);
		}
	}
}

async function alertChange() {
	const result = await isLandscape();
	if (changeSubscriptions.length > 0) {
		changeSubscriptions.forEach(e => e.func(result));
	}
}

window.onresize = () => {
	if (isXamarin()) {
		canRenderLandscape().then(result => {
			if (result === true) {
				alertChange();
			}
		});
	}
};

export {
	isLandscape,
	allowLandscape,
	landscapeAllowed,
	toggleAllowLandscape,
	toggleForceLandscape,
	forceLandscape,
	resetLandscape,
	subscribeToLandscapeChange,
	unsubscribeFromLandscapeChange,
	getCurrentAppVersion,
	getCurrentOrientation,
	getAllowedOrientation,
	isXamarin
}
